import { useTranslation } from "react-i18next";

import { getLoginBgImage } from "../../lib/utils";

import "./LoadingView.css";

const LoadingView = (props: any) => {
  const { t } = useTranslation();

  const loginImage = getLoginBgImage();

  return (
    <div
      className="Loading-Box"
      style={{
        height: "100vh",
        backgroundImage: `url(${loginImage})`,
        backgroundSize: "cover",
      }}
    >
      <div className="Loading-Text">{t("loading")}</div>
    </div>
  );
};

export default LoadingView;
